import { AdminBarberRepository } from "../../Repository";

export async function updateSubscriptionInfo(
  repository: AdminBarberRepository
): Promise<boolean> {
  return repository.updateSubscriptionInfo();
}
